export type ThemeConfig = {
  isAdminSite?: boolean;
  isSubdomain?: boolean;
  whiteLabelConfig?: {
    bgColor?: string;
    primaryColor?: string;
    primaryContrastText?: string;
    secondaryColor?: string;
  };
};

export const defaultSubdomainWhiteLabelConfig: ThemeConfig['whiteLabelConfig'] =
  {
    bgColor: '#F0F1EE',
    primaryColor: '#ffffff',
    primaryContrastText: '#000000',
    secondaryColor: '#ffffff',
  };

export const defaultGreenSiteWhiteLabelConfig: ThemeConfig['whiteLabelConfig'] =
  {
    bgColor: '#F0F1EE',
    primaryColor: '#56b26c',
    primaryContrastText: '#ffffff',
    secondaryColor: '#2196F3',
  };
